import React from "react";
import instagram from "../assets/instagram.svg";
import Circles from "../components/Circles";
import Button from "../components/Button";
import { usePoints } from "../providers/PointsContext";
import { useCurrentPage } from "../providers/CurrentPageContext";

function Results() {
  const [points, setPoints] = usePoints();
  const [currentPage, setCurrentPage] = useCurrentPage();

  return (
    <section className="bg-petrol-500">
      <div className="container">
        <h1 className="mb-[65px]">Bra jobbat!</h1>
        {/*<p className="font-bold text-[26px] leading-none mb-5">
          Ditt resultat:
  </p>*/}
        <div className="w-[200px] h-[200px] bg-primary rounded-full flex flex-col justify-center items-center">
          <p className="font-bold text-6xl leading-none">{Intl.NumberFormat('sv-SE').format(points.score)}</p>
          <p className="font-bold text-[26px] leading-none">poäng</p>
        </div>
        <p className="mt-2 mb-3 text-center"><strong>Du fick {points.correctAnswers} rätt av 10 <br/>på totalt {Math.round(points.answerTime)} sekunder</strong></p>
        <div className="flex gap-[10px] mt-8 mb-10 cursor-pointer">
          {/* <img src={instagram} alt="instagram" />
          <p className="font-bold">Dela</p> */}
        </div>
        <div className="flex w-full flex-col items-center gap-[30px]">
          {/*<Button
            text="Tävla med ditt resultat"
            buttonClass="primary"
            onClick={() => setCurrentPage(5)}
          />*/}
          <Button
            text="Försök igen"
            buttonClass="secondary"
            onClick={() => setCurrentPage(1)}
          />
        </div>
      </div>
    </section>
  );
}

export default Results;
